import { Component, Input } from '@angular/core';
import { Params } from '@angular/router';
import { SliderConfig } from '@planone/bau365/data-access-screensize';
import { WatchlistPageContext } from '@planone/bau365/data-access-user';
import { Exhibitor } from '@planone/bau365/util-fair-data';

@Component({
  selector: 'bau365-exhibitor-card-list',
  templateUrl: './exhibitor-card-list.component.html',
  styleUrls: ['./exhibitor-card-list.component.scss'],
})
export class ExhibitorCardListComponent {
  @Input() exhibitors?: Exhibitor[];
  @Input() parent?: Exhibitor;
  @Input() size: string | null | undefined;
  @Input() cardSliderConfig: SliderConfig | null | undefined;
  @Input() context?: WatchlistPageContext;
  @Input() imageZoomed?: boolean;
  @Input() moreRouterLink: any[] | string | null | undefined;
  @Input() moreQueryParams: Params | null = null;

  identifyExhibitor(_index: number, exhibitor: Exhibitor): string {
    return exhibitor.id;
  }
}
